import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Link, Navigate, redirect } from "react-router-dom";
import {
  Autocomplete,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  TextareaAutosize,
} from "@mui/material";
// import Textarea from "@mui/joy/Textarea";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const fd = new FormData();
export default class UpdateTestimonials extends Component {
  state = {
    allJobs: [],
    message: "",
    notification: false,
    per_pge: 20,
    page_no: 1,
    profile_name: "",
    countrySearch: "",
    stateSearch: "",
    cityHubSearch: "",
    citySearch: "",
    allCountries: [],
    allStates: [],
    allCities: [],
    cityHubs: [],
    allQualifications: [],
    allCompanies: [],
    qualificationSearch: "",
    companySearch: "",
    min_qualification: 0,
    country: 0,
    state: 0,
    city: 0,
    city_hub: 0,
    company_id: 0,
    job_type: "",
    billing_cycle: "",
    onboarding_fee: "",
    onboarding_price: 0,
    application_link: "",
    audio_file: [],
    compensation: "",
    description: "",
    tags: "",
    redirect: false,
    delivery_item: "",
    per_packet_charge: "",
    daily_avg_volume: "",
    range_minimum: "",
    range_maximum: "",
    hours_shift: "",
    pan_card: "yes",
    aadhar_card: "yes",
    driving_license: "yes",
    bank_account: "yes",
    bike_requied: "yes",
    ev_on_rent: "no",
    chargeable_battery: 0,
    swappable_battery: 0,
    ev_security_deposit: "",
    job_offer: "",
    client_image: {},
    client_name: "",
    testimonial: "",
    links: "",
    testimonial_from: "",
  };

  componentDidMount() {
    this.getSingleTestimonial();
  }

  getSingleTestimonial = async () => {
    if (init() === "success") {
      await axios
        .get(Constants.getUrls.getAllTestimonials + "/" + window.location.pathname.split("/")[2])
        .then((resp) => {
          console.log(resp);

          this.setState({
            // client_image: resp.data.data.image,
            client_name: resp.data.data.name,
            testimonial: resp.data.data.content,
            testimonial_from: resp.data.data.testimonial_from,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    fd.append("name", this.state.client_name);
    fd.append("client_image", this.state.client_image);
    fd.append("testimonial_from", this.state.testimonial_from);
    fd.append("content", this.state.testimonial);
    // return;
    if (init() === "success") {
      axios
        .put(Constants.putUrls.updateTestimonial + window.location.pathname.split("/")[2], fd)
        .then((resp) => {
          // console.log(resp);
          fd.delete("image");
          this.setState({
            notification: true,
            message: resp.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "", redirect: true });
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err.response.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 5000);
        });
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/testimonials" />;
    } else {
      return (
        <div>
          <div>
            <DashboardLayout>
              <DashboardNavbar />
              <MDBox pt={6} pb={3}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Add Testimonial
                    </MDTypography>
                  </MDBox>
                  {/* <Grid item sm={4} px={2} align="right">
                    <Link to="/admin/addNewJob">
                      <MDButton variant="contained" size="small" color="primary">
                        Create Job
                      </MDButton>
                    </Link>
                  </Grid> */}
                  <MDBox py={3} px={2}>
                    <form onSubmit={this.handleSubmit}>
                      <Grid container sm={12} spacing={2}>
                        <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Client Name"
                            value={this.state.client_name}
                            name="client_name"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <TextField
                            type="file"
                            label="Client Image"
                            name="client_image"
                            focused
                            onChange={(e) => {
                              this.setState({
                                client_image: e.target.files[0],
                              });
                            }}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <InputLabel>Select Testimonial From</InputLabel>
                          <Select
                            value={this.state.testimonial_from}
                            onChange={(e) => this.setState({ testimonial_from: e.target.value })}
                            name="blog_type"
                            label="Select Subject"
                            // style={{
                            //   height: "45px",
                            // }}
                            required
                            style={{ width: "100%", height: "45px", color: "#111" }}
                          >
                            <MenuItem value="">Testimonial From</MenuItem>

                            <MenuItem value="student" style={{ color: "#111" }}>
                              Student
                            </MenuItem>
                            <MenuItem value="parent" style={{ color: "#111" }}>
                              Parent
                            </MenuItem>
                            <MenuItem value="partner" style={{ color: "#111" }}>
                              Partner
                            </MenuItem>
                          </Select>
                        </Grid>
                        <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Testimonial"
                            name="testimonial"
                            value={this.state.testimonial}
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%", marginTop: "12px" }}
                          />
                        </Grid>
                      </Grid>

                      <Grid align="left" mt={2}>
                        <MDButton variant="contained" size="small" color="info" type="submit">
                          {this.state.loading ? "Updating..." : "Update"}
                        </MDButton>
                      </Grid>
                    </form>
                  </MDBox>
                  <>
                    <MDSnackbar
                      color="success"
                      icon="notifications"
                      title="ASA-Agrotech Testimonials"
                      content={this.state.message}
                      dateTime="Just now"
                      open={this.state.notification}
                      //   close={toggleSnackbar}
                    />
                  </>
                </Card>
              </MDBox>
            </DashboardLayout>
          </div>
        </div>
      );
    }
  }
}
